<template>
  <div v-if="isLoadingError" class="accent-color box" @click="handleReload">
    <span>{{ '( ´•︵•` ) 加载出错啦，点击页面重新加载' }}</span>
  </div>
  <div v-else>
    <div v-if="!length"  class="accent-color box">
      <span v-if="isLoading">- ( ´Д`)ﾉ 努力加载中</span>
      <div v-else>{{ '( ´•︵•` ) ' + emptyTip }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    isLoading: Boolean,
    isLoadingError: Boolean,
    length: Number,
    emptyTip: {
      type: String,
      default: '空空如也',
    },
  },
  methods: {
    async handleReload() {
      this.$emit('reload');
    },
  },
};
</script>

<style src="./index.css" scoped/>
